export const ROUTES = {
    HOME: '/',
    CART: '/cart',
    PROFILE: '/profile',
    CATEGORY: '/categories/:id',
    PRODUCT: '/products/:id',
};